import { BudgetRequestListItemDto } from '../../../types';

interface BudgetDeleteConfirmationModalProps {
  request: BudgetRequestListItemDto;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function BudgetDeleteConfirmationModal({
  onConfirm,
  onCancel,
  isLoading = false,
}: BudgetDeleteConfirmationModalProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(20, 30, 50, 0.55)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          width: '380px',
          maxWidth: '95vw',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: '#1a3bcc',
            color: 'white',
            padding: '14px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <span style={{ fontSize: '18px', filter: 'brightness(0) invert(1)' }}>⚠️</span>
          <h2 style={{ fontSize: '14px', fontWeight: 800, margin: 0 }}>Delete Budget Request</h2>
        </div>

        {/* Body */}
        <div style={{ padding: '22px' }}>
          <p
            style={{
              fontSize: '13px',
              color: '#222',
              lineHeight: 1.55,
              margin: 0,
            }}
          >
            Are you sure you want to delete this budget request?{' '}
            <strong>This action cannot be undone.</strong>
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            padding: '14px 22px 20px',
            borderTop: '1px solid #eee',
          }}
        >
          <button
            onClick={onCancel}
            style={{
              background: '#fff',
              color: '#444',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '9px 22px',
              fontSize: '13px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: '#a01a23',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '9px 24px',
              fontSize: '13px',
              fontWeight: 700,
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.6 : 1,
            }}
            disabled={isLoading}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
